import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface VietQrBankDto {
  id: number;
  name: string;
  code: string;
  bin: string;
  shortName: string;
  logo: string;
  transferSupported: number;
  lookupSupported: number;
}

interface VietQrBankListResponse {
  code?: string;
  desc?: string;
  data?: VietQrBankDto[];
}

@Injectable({ providedIn: 'root' })
export class VietQrBankService {
  private http: HttpClient;
  private cached$?: Observable<VietQrBankDto[]>;

  constructor(httpBackend: HttpBackend) {
    // Bypass app interceptors (avoid adding auth headers/CORS issues)
    this.http = new HttpClient(httpBackend);
  }

  getBanks(): Observable<VietQrBankDto[]> {
    if (this.cached$) return this.cached$;

    this.cached$ = this.http.get<VietQrBankListResponse>('https://api.vietqr.io/v2/banks').pipe(
      map((res) => (Array.isArray(res?.data) ? res.data : [])),
      shareReplay(1),
      catchError((err) => {
        this.cached$ = undefined;
        return throwError(err);
      })
    );

    return this.cached$;
  }
}
